// @mui
import { ListItemButton, ListItemIcon, Popover, styled } from '@mui/material';
// utils
// config
import { ICON, NAV } from '../../../config-global';
//
import { DARK_TEXT } from '../../../theme/palette';
import { NavItemProps } from '../types';

// ----------------------------------------------------------------------

type StyledItemProps = Omit<NavItemProps, 'item'>;

export const StyledItem = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'open',
})<StyledItemProps>(({ active, disabled, open, depth, theme }) => {
  const isLight = theme.palette.mode === 'light';

  const subItem = depth !== 1;

  const activeStyle = {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    ...(!isLight && {
      color: theme.palette.primary.light,
    }),
  };

  const activeSubStyle = {
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    ...(!isLight && {
      color: theme.palette.primary.light,
    }),
  };

  const hoverStyle = {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover,
  };

  return {
    flexShrink: 0,
    display: 'inline-flex',
    padding: theme.spacing(0, 2),
    color: DARK_TEXT.primary,
    border: '1px solid transparent',
    borderRadius: theme.shape.borderRadius * 4,
    height: NAV.H_DASHBOARD_ITEM_HORIZONTAL,
    transition: theme.transitions.create(
      ['color', 'background-color', 'border-color'],
      { duration: theme.transitions.duration.shorter },
    ),
    '&:hover': hoverStyle,
    // Sub item
    ...(subItem && {
      width: '100%',
      margin: 0,
      padding: theme.spacing(0, 2),
    }),
    // Active item
    ...(active && {
      ...activeStyle,
      '&:hover': {
        ...activeStyle,
      },
    }),
    // Active sub item
    ...(subItem &&
      active && {
        ...activeSubStyle,
        '&:hover': {
          ...activeSubStyle,
        },
      }),
    // Open
    ...(open && !active && hoverStyle),
    // Disabled
    ...(disabled && {
      '&.Mui-disabled': {
        opacity: 0.64,
      },
    }),
  };
});

// ----------------------------------------------------------------------

export const StyledIcon = styled(ListItemIcon)({
  marginRight: 8,
  flexShrink: 0,
  width: ICON.NAV_ITEM_HORIZONTAL,
  height: ICON.NAV_ITEM_HORIZONTAL,
});

// ----------------------------------------------------------------------

export const StyledPopover = styled(Popover)(({ theme }) => ({
  pointerEvents: 'none',
  '& .MuiPopover-paper': {
    width: 'auto',
    minWidth: 200,
    pointerEvents: 'auto',
    padding: theme.spacing(1),
    marginTop: theme.spacing(0.5),
    boxShadow: theme.customShadows.dropdown,
    borderRadius: Number(theme.shape.borderRadius) * 1.5,
    backgroundColor: '#052330',
  },
}));
